import React, { useState, useEffect, Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import Widget from "./pages/Widjet/Widget";
import ChatWidget from "./pages/ChatWidjet/ChatWidget";
import { AuthProvider } from "./contexts/AuthContext";
import { apiService } from "./services/api";
import { isWidgetRoute } from "./utils/widgetConfig";

import "./App.css";

// Тяжёлые страницы админки грузятся отдельными чанками и не должны попадать
// в бандл /widget и /chat-widget, которые встраиваются на сайты клиентов.
const Home = lazy(() => import("./pages/Home/Home"));
const ClothesManager = lazy(() => import("./pages/ClothesManager"));
const VirtualTryOn = lazy(() => import("./pages/VirtualTryOn"));
const OpenRouterTryOn = lazy(() => import("./pages/OpenRouterTryOn"));
const Login = lazy(() => import("./pages/Login"));
const Profile = lazy(() => import("./pages/Profile"));
const AccountManager = lazy(() => import("./pages/AccountManager"));
const APIRequestHistory = lazy(() => import("./pages/APIRequestHistory"));
const DebugAPI = lazy(() => import("./pages/DebugAPI"));

function App() {
  const [clothes, setClothes] = useState([]);
  const [clothesTotal, setClothesTotal] = useState(0);

  useEffect(() => {
    // Виджетам (/widget, /chat-widget) список одежды не нужен - они ищут
    // товар отдельным запросом по URL страницы (useClothFinder). Пропускаем
    // здесь загрузку, чтобы не тратить лишний запрос при встраивании виджета.
    if (isWidgetRoute()) {
      return;
    }

    const loadClothes = async () => {
      try {
        const result = await apiService.getClothes();
        setClothes(result.items);
        setClothesTotal(result.total);

      } catch (error) {
        console.error("Ошибка загрузки одежды:", error);
      }
    };

    loadClothes();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Suspense fallback={null}>
        <Routes>
          {/* Публичные роуты для виджетов - без Header */}
          <Route path="/widget" element={<Widget />} />
          <Route path="/chat-widget" element={<ChatWidget />} />

          {/* Основные роуты с Header */}
          <Route
            path="/"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <Home
                    clothes={clothes}
                    setClothes={setClothes}
                    clothesTotal={clothesTotal}
                  />
                </main>
              </div>
            }
          />
          <Route
            path="/login"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <Login />
                  
                </main>
              </div>
            }
          />
          <Route
            path="/clothes"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <ClothesManager
                      clothesTotal={clothesTotal}
                      setClothesTotal={setClothesTotal}
                    />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/try-on"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <VirtualTryOn clothes={clothes} />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/openrouter-try-on"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <OpenRouterTryOn clothes={clothes} />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/profile"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/accounts"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute requireAdmin>
                    <AccountManager />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/history"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <APIRequestHistory />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/debug"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <DebugAPI />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
          <Route
            path="/chat"
            element={
              <div className="min-h-screen bg-gray-50">
                <Header />
                <main className="container mx-auto px-4 py-8">
                  <ProtectedRoute>
                    <ChatWidget />
                  </ProtectedRoute>
                </main>
              </div>
            }
          />
        </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
}

export default App;
